import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"
import DrawerCom from "./DrawerCom"

import BaseBtnCom from "../BaseBtnCom"
import { CancelTextBtnWrap, DrawerWinOneTileWrap, DrawerWinTwoTileWrap, PaddingLeftRightWrap } from "./DrawerStyle"
import WarnBarCom from "components/WarnBarCom"
import { useCallback, useEffect, useState } from "react"
import { Row } from "style/preset"

import {ReactComponent as SlippageSvg } from 'assets/svgs/icn_slippage.svg'
import {ReactComponent as PriceImpactSvg } from 'assets/svgs/price_impact.svg'
import { ReactComponent as WarnSvg } from 'assets/svgs/warn_icon.svg'
import { Tooltip } from "react-tooltip"
import { ToolTipCom } from "components/TransferInfoCom"
import { useAppSelector } from "hooks/redux/hooks"
interface Props {
    open: boolean
    closeChange?: (isOpen: boolean) => void
    onComplete?: (obj?: any) => void
}

const DrawerSlippageCom = ({open, closeChange = (isOpen) => {}, onComplete = (obj) => {}}: Props) => {
    const { priceImpact, slippage } = useAppSelector((state) => state.coreInfo)

    /**
     * 资源初始化
     */
    const fnInit = useCallback(() => {
        if(open) {
            // 初始化资源

        } else {
            // 清理资源

        }
    }, [open])

    useEffect(() => {
        fnInit()
    }, [fnInit])

    /**
     * 关闭回调
     */
    const [closeRandom, setCloseRandom] = useState(0)
    const fnClosed = (closed: boolean) => {
        closeChange(closed)
        setCloseRandom(0)
    }
    const fnCloseWin = useCallback(() => {
        setCloseRandom(closeRandom + 1)
    }, [closeRandom])

    /**
     * 完成回调
     */
    const fnConfirm = () => {
        onComplete();
        fnCloseWin()
    }

    return open ? <DrawerCom isOpen={open} closeRandom={closeRandom} onClose={fnClosed}>
        <DrawerContentWrap $isError={true}>
            <PaddingLeftRightWrap>
                <DrawerWinOneTileWrap>Proceeding may result in an unfavorable trade</DrawerWinOneTileWrap>
                <DrawerWinTwoTileWrap $mb="30px">Your current trading setup may not yield favorable results. Proceed with caution.</DrawerWinTwoTileWrap>

                <DesBoxWrap $active={+slippage >= 20}>
                    <Row $pointer data-tooltip-id="tootltip_slippage">
                        <SlippageSvgWrap></SlippageSvgWrap>
                        <Row $ml="12px" $mr="8px">
                            <StyledContainer $fontWeight5 $mr="4px">Estimated slippage:</StyledContainer>
                            <StyledContainer $fontWeight6 $roobertSemiBold>{slippage}%</StyledContainer>
                        </Row>
                        <WarnSvgWrap></WarnSvgWrap>
                    </Row>
                </DesBoxWrap>
                <StyledContainer $height="10px"></StyledContainer>
                <DesBoxWrap $active={+priceImpact >= 20}>
                    <Row $pointer data-tooltip-id="tootltip_price"> 
                        <PriceImpactSvgWrap></PriceImpactSvgWrap>
                        <Row $ml="12px" $mr="8px">
                            <StyledContainer $fontWeight5 $mr="4px">Price impact:</StyledContainer>
                            <StyledContainer $fontWeight6 $roobertSemiBold>{priceImpact}%</StyledContainer>
                        </Row>
                        <WarnSvgWrap></WarnSvgWrap>
                    </Row>

                </DesBoxWrap>
                <Tooltip id="tootltip_slippage" style={{ backgroundColor:  'transparent', width: '258px', padding: '0'}}>
                    <ToolTipCom>
                        {`You agree to receiving up to ${slippage}% less than the estimated output.`}
                    </ToolTipCom>
                </Tooltip>
                <Tooltip id="tootltip_price" style={{ backgroundColor:  'transparent', width: '258px', padding: '0'}}>
                    <ToolTipCom>
                        Possible change in price due to the size of your transaction.
                    </ToolTipCom>
                </Tooltip>

                <StyledContainer $height="20px"></StyledContainer>
                <WarnBarCom isError={false} desc="Continuing implies acknowledgement of the potential loss"></WarnBarCom>
            </PaddingLeftRightWrap>

            <PartingLineWrap></PartingLineWrap>

            <PaddingLeftRightWrap>
                <StyledContainer $fontSize="14px" $fontWeight6 $lineHeight="16px" $roobertSemiBold>Are you sure you want to continue?</StyledContainer>
                <StyledContainer $height="20px"></StyledContainer>

                <BaseBtnCom type="1" title="Swap now" onClick={fnConfirm}></BaseBtnCom>

                <CancelTextBtnWrap onClick={() => setCloseRandom(closeRandom + 1)}>Cancel</CancelTextBtnWrap>
            </PaddingLeftRightWrap>
        </DrawerContentWrap>
    </DrawerCom> : <></>
}

const DrawerContentWrap = styled(StyledContainer)<{$isError: boolean}>`
    ${
        ({$isError, theme}) => $isError ? css`
         
        ` : css`
        `
    }
`

const SlippageSvgWrap = styled(SlippageSvg)`
    width: 14px;
    height: 14px;
`

const PriceImpactSvgWrap = styled(PriceImpactSvg)`
    width: 14px;
    height: 14px;
`

const WarnSvgWrap = styled(WarnSvg)`
    width: 14px;
    height: 14px;
`

const DesBoxWrap = styled(Row)<{$active: boolean}>`
    padding: 18px 0 18px 15px;
    border-left: 1px dashed #B5B7BA;
    font-size: 14px;
    line-height: 16px;

    ${
        ({$active}) => $active ? css`
            border-color: #E000E0;
            &>div div {
                color: #E000E0;
            }

            ${SlippageSvgWrap}, ${PriceImpactSvgWrap}, ${WarnSvgWrap} {
                rect, path {
                    fill: #E000E0;
                }
            }
        ` : css`
            ${SlippageSvgWrap}, ${PriceImpactSvgWrap}, ${WarnSvgWrap} {
                rect, path {
                    fill: #0A0A0A;
                }
            }
        `
    }
`

const PartingLineWrap = styled(StyledContainer)`
    height: 1px;
    width: 100%;
    margin: 30px 0;
    background-color: #DFE0E2;
`

export default DrawerSlippageCom